import { writable } from 'svelte/store';

import type { BallPageType } from '../constants/pageType';
import { JUMP_TYPE_ENUM } from '../enums';
import { resolveBallPageId } from '../utils/ballPageId';

export const isLogin = writable(false);
export const userID = writable('');
export const PhoneCell = writable('');
export const cookieHeight = writable(0);
export const bottomButtonHeight = writable(0);
export const isCookiesShow = writable(false);
export const omegaParams = writable<Record<string, unknown>>({});
export const visible = writable(true);
export const isJumpOneLink = writable(false);
export const jumpType = writable(JUMP_TYPE_ENUM.TO_H5CREDITCARD);
export const pageId = writable(resolveBallPageId());
export const startTime = writable(Date.now());
export const regPageExposeAt = writable(0);
export const activityId = writable('');
/** 当前 BALL 页面类型，由各 entry main-*.ts 启动时写入 */
export const ballPageType = writable<BallPageType>('regular');
export const trackRoute = writable('/');
export const showRetentionPopup = writable(true);
export const isLoading = writable(false);
